export type CohortLessonProgress = {
  readonly planned: number;
  readonly assigned: number;
  readonly completed: number;
};

type CohortLessonProgressBarProps = {
  readonly progress: CohortLessonProgress;
};

export function CohortLessonProgressBar({ progress }: CohortLessonProgressBarProps) {
  const { planned, assigned, completed } = progress;
  const total = planned + assigned + completed;
  if (total === 0) {
    return <p className="cohort-progress-empty muted small">No lessons in the lesson plan yet.</p>;
  }

  const pct = (n: number) => `${(n / total) * 100}%`;

  return (
    <div className="cohort-progress" role="img" aria-label={`Lesson progress: ${completed} completed, ${assigned} assigned, ${planned} planned`}>
      <div className="cohort-progress-track">
        {completed > 0 ? (
          <span className="cohort-progress-seg cohort-progress-seg--completed" style={{ width: pct(completed) }} />
        ) : null}
        {assigned > 0 ? (
          <span className="cohort-progress-seg cohort-progress-seg--assigned" style={{ width: pct(assigned) }} />
        ) : null}
        {planned > 0 ? (
          <span className="cohort-progress-seg cohort-progress-seg--planned" style={{ width: pct(planned) }} />
        ) : null}
      </div>
      <ul className="cohort-progress-legend">
        {completed > 0 ? (
          <li>
            <span className="cohort-progress-dot cohort-progress-dot--completed" aria-hidden />
            {completed} completed
          </li>
        ) : null}
        {assigned > 0 ? (
          <li>
            <span className="cohort-progress-dot cohort-progress-dot--assigned" aria-hidden />
            {assigned} assigned
          </li>
        ) : null}
        {planned > 0 ? (
          <li>
            <span className="cohort-progress-dot cohort-progress-dot--planned" aria-hidden />
            {planned} planned
          </li>
        ) : null}
      </ul>
    </div>
  );
}
